import { render, staticRenderFns } from "./LostPasswordPage.vue?vue&type=template&id=3e564876&scoped=true&"
import script from "./LostPasswordPage.vue?vue&type=script&lang=js&"
export * from "./LostPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./LostPasswordPage.vue?vue&type=style&index=0&id=3e564876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e564876",
  null
  
)

export default component.exports